import React, { FC } from 'react'

import { LoadMore } from 'components'

import { UsersTable, UsersActions } from 'modules/Users/components'
import { useListUser } from '../serviceHooks'

const UsersContainer: FC = () => {
  const {
    tableUserList,
    increaseUsersOffset,
    listUserLoading,
    total,
    onNewUser,
    onUpdateUser,
    searchName,
    userSearchNameVar
  } = useListUser()

  return (
    <>
      <UsersActions
        handleSearchUser={userSearchNameVar}
        loading={listUserLoading && !!searchName}
        onNewUser={onNewUser}
      />
      <UsersTable usersList={tableUserList} onUpdateUser={onUpdateUser}/>
      <LoadMore
        label="users on Storybox"
        onLoad={increaseUsersOffset}
        isItemsLoading={listUserLoading}
        itemsTotal={total}
        itemsCount={tableUserList.length}
      />
    </>
  )
}

export default UsersContainer
